import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { take } from 'rxjs/operators';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { ApiError, MessageService } from '../../../core';
import { RegiaoFilter } from '../filter/regiao-filter';
import { RegiaoCrudHttpService } from '../services';
import { regiaoSituacaoAtiva } from '../situacao';

@Component({
    selector: 'sgt-regiao-multiselect',
    templateUrl: './regiao-multiselect.component.html',
    styleUrls: ['./regiao-multiselect.component.less']
})
export class RegiaoMultiselectComponent implements OnInit, OnDestroy {
    /** Regiões selecionadas */
    @Input() idsRegioes: number[];
    /** Ao alterar a seleção das regiões */
    @Output() idsRegioesChange = new EventEmitter<number[]>();

    /** Se deve exibir a opção de selecionar a opção de região nula ou seja, para filtrar registros que não possuem a região */
    @Input() showNullOption = false;
    /** Valor da opção de selecionar a região nula */
    @Input() nullOption = false;
    /** Ao alterar a seleção da opção da região nula */
    @Output() nullOptionChange = new EventEmitter<boolean>();

    /** Input Name */
    @Input() nameSomenteAtivas = 'multiselectRegiaoSomenteAtivas';
    /** Input ID */
    @Input() idSomenteAtivas = 'multiselectRegiaoSomenteAtivas';
    /** Se deve filtrar somente as regiões em andamento */
    @Input() somenteAtivas = true;
    @Output() somenteAtivasChange = new EventEmitter<boolean>();

    /** ID do representante para filtar as regiões */
    @Input() idRepresentanteFilter: number = null;
    /** ID do estado para filtrar as regiões */
    @Input() idEstadoFilter: number = null;

    /** Ao destruir o multiselect */
    @Output() onDestroy = new EventEmitter<void>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma região';
    @Input() checked = 'Região';
    @Input() checkedPlural = 'Regiões';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma região encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private messageService: MessageService,
                private regiaoCrudHttpService: RegiaoCrudHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-regiao ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.search();
    }

    toggleSomenteAtivas(value: boolean) {
        this.somenteAtivas = value;
        this.somenteAtivasChange.emit(this.somenteAtivas);
        this.search();
    }

    /** Cria o filter para pesquisar as regiões */
    private createFilter(): RegiaoFilter {
        const filter = new RegiaoFilter();

        // Somente ativas
        if (this.somenteAtivas) {
            filter.situacoes = [regiaoSituacaoAtiva.id];
        }
        // Representante
        if (this.idRepresentanteFilter) {
            filter.idRepresentante = this.idRepresentanteFilter;
        }
        // Estado
        if (this.idEstadoFilter) {
            filter.idEstado = this.idEstadoFilter;
        }

        return filter;
    }

    /** Cria as regiões para o multiselect */
    private search() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const filter  = this.createFilter();
        this.regiaoCrudHttpService.searchWithFilter(filter, 0, null, null, 3, 'asc')
            .pipe(
                take(1)
            )
            .subscribe(
                response => {
                    const regioes = response?.data ?? [];

                    // Adicionando a opção de "Sem Região"
                    if (this.showNullOption) {
                        selects.push({
                            id: 0,
                            name: 'SEM REGIÃO'
                        });
                    }

                    regioes?.forEach(regiao => {
                        selects.push({
                            id: regiao.id,
                            name: regiao.nome
                        });
                    });

                    this.options = selects;
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar as regiões', error);
                }
            );
    }


    /** Ao alterar a seleção da opção região nula */
    private onChangeNullOption() {
        this.nullOption = this.idsRegioes.includes(0);
        this.nullOptionChange.emit(this.nullOption);

    }

    /** Ao alterar a seleção das regiões */
    onChange() {
        this.onChangeNullOption();
        this.idsRegioesChange.emit(this.idsRegioes);
    }

    ngOnDestroy() {
        this.onDestroy.emit();
    }
}
